<template>
<div class="bindBankCard">
  <div class="bankCard-top">
    <div class="iconfont iconzuojiantou jian"></div>
    <div>绑定银行卡</div>
    <div></div>
  </div>
  <div class="bankCard-form">
    <div class="bankCard-form-title">
      <div class="title-top">添加本人银行卡</div>
      <div class="title-bottom">绑定银行卡，即可激活平安银行电子账户用于交易</div>
    </div>
    <van-form>
      <van-field
          label="用户姓名"
          placeholder="用户姓名"
          class="field-bottom"
          readonly
          :value="userName"
        />
        <van-field
          label="身份证号"
          placeholder="身份证号"
          class="field-bottom"
          readonly
          :value="idNo"
        />
        <van-field
          label="银行卡号"
          placeholder="请输入银行卡号"
          class="field-bottom"
          v-model="formData.bankNo"
        />
        <van-field
          label="手机号"
          placeholder="请输入银行卡绑定手机号"
          class="field-bottom"
          v-model="formData.mobile"
        />
    </van-form>
  </div>

  <div class="bankCard-sure" @click="onSure">确定</div>
  <!-- 弹框 -->
  <van-overlay :show="overlayShow">
      <div class="card-bind-wrapper" @click.stop>
        <div class="card-bind-block">
          <div class="bind-block-title">绑定银行卡验证码</div>
          <div class="bind-block-detail">
            <div class="bind-block-detail-send">
              请注意查收{{phone}}短信验证码
            </div>
          </div>
          <div class="bind-field-code">
            <van-field
              v-model="formData.smsCode"
              input-align="left"
              clearable
              center
              placeholder="请输入短信验证码"
              class="bink-field-input-back"
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  @click="sendCode"
                  v-show="codeShow"
                  >获取验证码</van-button
                >
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  :disabled="disCode"
                  @click="sendCode"
                  v-show="!codeShow"
                  >{{ count }}s</van-button
                >
              </template>
            </van-field>
            </div>

          <div class="bind-modify-submit">
            <div class="bind-modify" @click="backModify">取消</div>
            <div class="bind-modif-rightline"></div>
            <div class="bind-submit" @click="onSubmit">确定</div>
          </div>
        </div>
      </div>
    </van-overlay>

</div>
  
</template>
<script>
import http from "../../api/index.js";
import config from "../../utils/config";
export default {
  data(){
    return{
      formData:{    
        bankNo:"",
        mobile:"",
      },
      idNo:"",
      userName:"",
      phone:"",
      overlayShow:false,
      bindShow: false,
      codeShow: true,
      count: "",
      timer: null,
      disCode: false,

    }
  },
  mounted(){
    this.h5UserHomeInfo()
    this. myWalletDedail()
  },
  methods:{
    h5UserHomeInfo(){
      http.post(config.h5UserHomeInfo).then(({code,data})=>{
        if(code===0){
          this.userName=data.userName;
          this.idNo=data.idNo;
          this.phone=data.mobile;
        }else{
          this.$toast.fail(message)
        }
        console.log(data)
      })
    },
    myWalletDedail(){
      http.post(config.myWallet).then(({code,data})=>{
        console.log(data)
      })
    },
    sendCode(){
      http.post(config.bindCardSendSmsd,this.formData).then(({code,data})=>{
        if(code===0 && data.code===200){
          this.timerFun()
        }
      })
    },
    timerFun() {
      // 倒计时
      this.disCode = true;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    onSubmit(){
      this.overlayShow=true;
    },
    onSure(){
      // if(!this.formData.bankNo){
      //   this.$toast.fail("请输入银行卡号");
      //   return false;
      // }
      // if(!this.formData.mobile){
      //   this.$toast.fail("请输入手机号");
      //   return false;
      // }
      this.overlayShow=true;
    },
    backModify(){
      this.overlayShow=false;
    }
  } 
}
</script>
<style lang="less" scoped>
.bindBankCard{
  .bankCard-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 20px;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }
  }
  .bankCard-form{
    .bankCard-form-title{
      padding: 30px 20px;
      text-align: left;
      .title-top{
        font-size: 32px;
        color: #222222;
        margin-bottom: 10px;
      }
      .title-bottom{
        font-size: 24px;
        color: #999999;
      }
    }
  }
  .bankCard-sure{
    width: 100%;
    height: 90px;
    line-height: 90px;
    background: #0681FD;
    border-radius: 5px;
    font-size: 32px;  
    color: #ffffff;
    position: fixed;
    bottom: 0;
  }
  .card-bind-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .card-bind-block {
    width: 90%;
    height: 490px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box;
    .bind-block-title {
      font-size: 32px;
      color: #333333;
      margin-bottom: 20px;
      font-weight: 500;
    }
    .bind-block-detail {
      color: #666666;
      font-size: 28px;
      margin-bottom: 60px;
      .bink-block-detail-send {
      }
      .bink-block-detail-get {
      }
    }
    .bind-field-code {
      .bind-block-code {
        width: 180px;
        height: 74px;
        background: #4da5ff;
        border: none;
        border-radius: 45px;
        height: 90px;
        margin-right: -25px;
      }
      .bink-field-input-back {
        background: rgba(6, 129, 253, 0.04);
        border-radius: 45px;
        height: 90px;
      }
    }
    .bind-modif-rightline {
      height: 100px;
      width: 1px;
      background: #ececec;
    }
    .bind-modify-submit {
      width: 100%;
      height: 100px;
      border-top: 1px solid #ececec;
      font-size: 34px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 60px;
      .bind-submit {
        color: #0681fd;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/bindBankCard/index.vue